var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.5,
    fill: "#CCCCCC",
    stroke: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6353 10.2408C18.9475 9.91972 19.4537 9.91972 19.7659 10.2408C20.078 10.5619 20.078 11.0825 19.7659 11.4036L12.3801 19L11.8149 18.4106C11.7046 18.2956 11.5111 18.0941 11.262 17.8349C10.8469 17.4031 10.4309 16.9713 10.0417 16.5683L10.0224 16.5484C9.22598 15.7239 8.34175 14.8208 8.35803 14.8319C7.98995 14.5812 7.88922 14.071 8.13305 13.6924C8.37687 13.3138 8.87292 13.2102 9.241 13.461C9.37827 13.5545 9.81933 14.005 11.1566 15.3893L11.176 15.4094C11.5626 15.8096 11.9753 16.2381 12.3875 16.6668L18.6353 10.2408Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedNote);
export default __webpack_public_path__ + "static/media/closed-note.0efbf451305ef12ed898655497afc5fe.svg";
export { ForwardRef as ReactComponent };